import React from 'react'
import img1x from 'assets/images/no-activity.png'
import img2x from 'assets/images/no-activity@2x.png'
import styles from './index.module.css'

/**
 * StatsTableEmpty component for displaying empty state in stats tables
 *
 * A functional component that shows a "no activity" message with illustration
 * when there is no data to display in analytics tables. Includes a customizable
 * call-to-action message.
 *
 * @param props - Component props
 * @param props.cta - Call-to-action text to display below the empty state message
 * @returns JSX element containing the empty state illustration and message
 */
const StatsTableEmpty = props => (
  <div className={styles.statsTableEmptyCont}>
    <img
      className={styles.statsTableEmptyImage}
      srcSet={`${img1x}, ${img2x} 2x`}
    />
    <div className={styles.statsTableEmptyHeader}>No activity here yet</div>
    <div className={styles.statsTableEmptyDesc}>{props.cta}</div>
  </div>
)

export default React.memo(StatsTableEmpty)
